import cartItemHtml from './cartItem.html';


class CartItemController {

    constructor($scope, $timeout, $state, cartItemService) {
        'ngInject';

        this.service = cartItemService;
        this.displayMode = null;
        this.model = null;

        $scope.$watch(() => this.cartItemId, (newVal, oldVal) => {
            if (!newVal) return;

            console.log('CartItemController::$watch -> cartItemId', newVal);

            this.displayMode = null;
            this.model = null;

            this.service.getCartItem(newVal).then(
                (rawResponse) => {
                    var response = rawResponse.data;

                    if (response && response.type === 'CartItemManually') {
                        if (response.productionFileExtension === 'svg') {
                            this.displayMode = 'manualSvg';
                            response.productionFile = window.atob(response.productionFile);
                            this.model = response;
                        } else {
                            this.displayMode = 'manualDifferent';
                            this.model = response.name;
                        }

                        return;
                    }

                    if (response && response.data) {
                        this.displayMode = 'configurator';
                        this.model = response.data;
                        return;
                    }

                    this.model = null;
                },
                (error) => {
                    console.log('CartItemController::getCartItem -> error', error);
                }
            );
        });

    }

}

let cartItemComponent = {
    bindings: {
        'cartItemId': '<'
    },
    template: cartItemHtml,
    controller: CartItemController
};

export default cartItemComponent;